
import { Union, Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { LabelInventoryKind_$reflection, activeConfiguration, textLinesFor, sampleValues, Placeholder_name, Placeholder_storage, Placeholder_code, resolveLines, sampleCodeFor, maxLabelsPerPrint, LabelPrintRequest, LabelPrintItem, LabelPrintResponse_$reflection, LabelPrintCandidate_$reflection, LabelPrintItem_$reflection } from "../Shared/Label.js";
import { int32_type, union_type, record_type, unit_type, lambda_type, bool_type, class_type, tuple_type, option_type, string_type, list_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { CustomerConfiguration_$reflection, FormState__getValidation, FormState__setValidationResponse_5219762A, FormState__startLoading, FormState_get_empty, RequestedValue$1, ClientApiResponse$1_$reflection, FormState_$reflection, RequestedValue$1_$reflection, LabelConfiguration_$reflection } from "../Shared/Shared.js";
import { difference, ofList, union, FSharpSet__Contains, empty } from "../fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { createObj, compareArrays } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { add, tryFind, FSharpMap__Add, empty as empty_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { printLabels, getLabelCandidates } from "../Requests/Labels.js";
import { tryHead, tryExactlyOne, length, singleton, head, toArray, ofArray, choose, isEmpty, map, filter, empty as empty_2 } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_OfPromise_either, Cmd_none } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_errorToast } from "../Components/Toast.js";
import { downloadPrintedLabels } from "./LabelPdf.js";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { toast } from "react-hot-toast";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ColumnDefinition$1, CellContent } from "../Widgets/Table/Types.js";
import { InfiniteTable } from "../Widgets/Table/InfiniteTable.js";
import Recycle_Bin_1 from "../../public/assets/icons/Recycle_Bin_1.svg";
import { TableControlElement$1, TableControl$1 } from "../Widgets/Table/Table.js";
import { iterate, empty as empty_3, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { TabsMenu } from "../Widgets/TabsMenu.js";
import { Select } from "../Components/Select.js";
import { defaultArg, orElse, map as map_1, unwrap, toArray as toArray_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Checkbox } from "../Components/Checkbox.js";
import { WarningAlertText, ErrorAlert, InformationAlert } from "../Components/Alert.js";
import { LabelPreview } from "../Components/LabelPreview.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { ModalSheet } from "../Components/ModalSheet.js";
import { TextButton, Button } from "../Components/Button.js";
import Printer from "../../public/assets/icons/Printer.svg";
import { Skeleton } from "../Components/Skeleton.js";
import { Dialog } from "../Components/Dialog.js";

function keyOf(candidate) {
    return [candidate.EntityId, candidate.StorageId];
}

class State extends Record {
    constructor(Items, Configuration, LogoUrl, Candidates, Removed, PreferredCodes, AssignCodes, FormState, Translate, OnClose, OnPrinted) {
        super();
        this.Items = Items;
        this.Configuration = Configuration;
        this.LogoUrl = LogoUrl;
        this.Candidates = Candidates;
        this.Removed = Removed;
        this.PreferredCodes = PreferredCodes;
        this.AssignCodes = AssignCodes;
        this.FormState = FormState;
        this.Translate = Translate;
        this.OnClose = OnClose;
        this.OnPrinted = OnPrinted;
    }
}

function State_$reflection() {
    return record_type("Labels.PrintLabelsDialog.State", [], State, () => [["Items", list_type(LabelPrintItem_$reflection())], ["Configuration", LabelConfiguration_$reflection()], ["LogoUrl", option_type(string_type)], ["Candidates", RequestedValue$1_$reflection(list_type(LabelPrintCandidate_$reflection()))], ["Removed", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [tuple_type(string_type, option_type(string_type))])], ["PreferredCodes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [tuple_type(string_type, option_type(string_type)), string_type])], ["AssignCodes", bool_type], ["FormState", FormState_$reflection()], ["Translate", lambda_type(string_type, string_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["OnPrinted", lambda_type(unit_type, unit_type)]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CandidatesFetched", "RemoveCandidates", "RestoreCandidates", "SelectCode", "SetAssignCodes", "Print", "Printed", "Downloaded", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Labels.PrintLabelsDialog.Msg", [], Msg, () => [[["Item", ClientApiResponse$1_$reflection(list_type(LabelPrintCandidate_$reflection()))]], [["Item", list_type(tuple_type(string_type, option_type(string_type)))]], [["Item", list_type(tuple_type(string_type, option_type(string_type)))]], [["Item1", tuple_type(string_type, option_type(string_type))], ["Item2", string_type]], [["Item", bool_type]], [], [["Item", ClientApiResponse$1_$reflection(LabelPrintResponse_$reflection())]], [["Item", LabelPrintResponse_$reflection()]], [["Item", class_type("System.Exception")]]]);
}

function init(items, configuration, logoUrl, canAssignCodes, translate, onClose, onPrinted) {
    return [new State(items, configuration, logoUrl, new RequestedValue$1(0, []), empty({
        Compare: (x, y) => (compareArrays(x, y) | 0),
    }), empty_1({
        Compare: (x_1, y_1) => (compareArrays(x_1, y_1) | 0),
    }), canAssignCodes, FormState_get_empty(), translate, onClose, onPrinted), getLabelCandidates(items, (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(8, [Item_1])))];
}

function selectedCandidates(state) {
    const matchValue = state.Candidates;
    if (matchValue.tag === 0) {
        return empty_2();
    }
    else {
        return filter((candidate) => {
            if (candidate.HasStock) {
                return !FSharpSet__Contains(state.Removed, keyOf(candidate));
            }
            else {
                return false;
            }
        }, matchValue.fields[0]);
    }
}

function newCodeOf(label) {
    const matchValue = label.CodeOrigin;
    switch (matchValue.tag) {
        case 0:
            return undefined;
        default:
            return label.Code;
    }
}

function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new State(state.Items, state.Configuration, state.LogoUrl, state.Candidates, union(state.Removed, ofList(msg.fields[0], {
                Compare: (x, y) => (compareArrays(x, y) | 0),
            })), state.PreferredCodes, state.AssignCodes, state.FormState, state.Translate, state.OnClose, state.OnPrinted), Cmd_none()];
        case 2:
            return [new State(state.Items, state.Configuration, state.LogoUrl, state.Candidates, difference(state.Removed, ofList(msg.fields[0], {
                Compare: (x_1, y_1) => (compareArrays(x_1, y_1) | 0),
            })), state.PreferredCodes, state.AssignCodes, state.FormState, state.Translate, state.OnClose, state.OnPrinted), Cmd_none()];
        case 3:
            return [new State(state.Items, state.Configuration, state.LogoUrl, state.Candidates, state.Removed, FSharpMap__Add(state.PreferredCodes, msg.fields[0], msg.fields[1]), state.AssignCodes, state.FormState, state.Translate, state.OnClose, state.OnPrinted), Cmd_none()];
        case 4:
            return [new State(state.Items, state.Configuration, state.LogoUrl, state.Candidates, state.Removed, state.PreferredCodes, msg.fields[0], state.FormState, state.Translate, state.OnClose, state.OnPrinted), Cmd_none()];
        case 5: {
            const items = map((candidate) => (new LabelPrintItem(candidate.Kind, candidate.EntityId, candidate.StorageId, tryFind(keyOf(candidate), state.PreferredCodes))), selectedCandidates(state));
            if (isEmpty(items)) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(state.Items, state.Configuration, state.LogoUrl, state.Candidates, state.Removed, state.PreferredCodes, state.AssignCodes, FormState__startLoading(state.FormState), state.Translate, state.OnClose, state.OnPrinted), printLabels(new LabelPrintRequest(items, state.AssignCodes), (Item) => (new Msg(6, [Item])), (Item_1) => (new Msg(8, [Item_1])))];
            }
        }
        case 6:
            if (msg.fields[0].tag === 1) {
                return [new State(state.Items, state.Configuration, state.LogoUrl, state.Candidates, state.Removed, state.PreferredCodes, state.AssignCodes, FormState__setValidationResponse_5219762A(state.FormState, msg.fields[0].fields[0]), state.Translate, state.OnClose, state.OnPrinted), Cmd_errorToast("validation.toast")];
            }
            else {
                return [state, Cmd_OfPromise_either((response_1) => {
                    const pr = downloadPrintedLabels(response_1.Configuration, response_1.Labels, state.LogoUrl);
                    return pr.then(() => response_1);
                }, msg.fields[0].fields[0], (Item_2) => (new Msg(7, [Item_2])), (Item_3) => (new Msg(8, [Item_3])))];
            }
        case 7: {
            const newCodes = choose(newCodeOf, msg.fields[0].Labels);
            return [new State(state.Items, state.Configuration, state.LogoUrl, state.Candidates, state.Removed, state.PreferredCodes, state.AssignCodes, FormState_get_empty(), state.Translate, state.OnClose, state.OnPrinted), Cmd_batch(ofArray([Cmd_ofEffect((_arg_1) => {
                const message = isEmpty(newCodes) ? state.Translate("labels.print.success") : ((state.Translate("labels.print.success_with_codes") + " ") + join(", ", newCodes));
                toast.success(message);
            }), Cmd_ofEffect((_arg_2) => {
                state.OnPrinted();
            }), Cmd_ofEffect((_arg_3) => {
                state.OnClose();
            })]))];
        }
        case 8:
            return [new State(state.Items, state.Configuration, state.LogoUrl, state.Candidates, state.Removed, state.PreferredCodes, state.AssignCodes, FormState_get_empty(), state.Translate, state.OnClose, state.OnPrinted), Cmd_errorToast("general.a_error_occured")];
        default:
            if (msg.fields[0].tag === 1) {
                return [new State(state.Items, state.Configuration, state.LogoUrl, new RequestedValue$1(1, [empty_2()]), state.Removed, state.PreferredCodes, state.AssignCodes, FormState__setValidationResponse_5219762A(state.FormState, msg.fields[0].fields[0]), state.Translate, state.OnClose, state.OnPrinted), Cmd_none()];
            }
            else {
                return [new State(state.Items, state.Configuration, state.LogoUrl, new RequestedValue$1(1, [msg.fields[0].fields[0]]), state.Removed, state.PreferredCodes, state.AssignCodes, state.FormState, state.Translate, state.OnClose, state.OnPrinted), Cmd_none()];
            }
    }
}

class CandidateTableRow extends Record {
    constructor(Key, Candidate) {
        super();
        this.Key = Key;
        this.Candidate = Candidate;
    }
}

function CandidateTableRow_$reflection() {
    return record_type("Labels.PrintLabelsDialog.CandidateTableRow", [], CandidateTableRow, () => [["Key", string_type], ["Candidate", LabelPrintCandidate_$reflection()]]);
}

function rowKey(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const storageId = _arg[1];
    const entityId = _arg[0];
    if (storageId == null) {
        return entityId;
    }
    else {
        return concat(entityId, "-", ...storageId);
    }
}

function CandidateTable(props) {
    let elems_2;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const patternInput_1 = reactApi.useState(true);
    const setIsActiveTabVisible = patternInput_1[1];
    const isActiveTabVisible = patternInput_1[0];
    const toRows = (candidates) => toArray(map((candidate) => {
        let tupledArg;
        return new CandidateTableRow((tupledArg = keyOf(candidate), rowKey(tupledArg[0], tupledArg[1])), candidate);
    }, candidates));
    let rows;
    const dependencies_1 = [props.Candidates];
    rows = reactApi.useMemo(() => toRows(props.Candidates), dependencies_1);
    let removedRows;
    const dependencies_1_1 = [props.RemovedCandidates];
    removedRows = reactApi.useMemo(() => toRows(props.RemovedCandidates), dependencies_1_1);
    const columns = [new ColumnDefinition$1("object", "", t("labels.print.column_object"), (row) => (new CellContent(0, [row.Candidate.DisplayName])), "none", "text"), new ColumnDefinition$1("storage", "", t("labels.print.column_storage"), (row_1) => (new CellContent(0, [row_1.Candidate.StorageName])), "none", "text"), new ColumnDefinition$1("code", "", t("labels.print.column_code"), (row_2) => {
        const matchValue = row_2.Candidate.ExistingCodes;
        return !isEmpty(matchValue) ? (new CellContent(0, [head(matchValue)])) : (new CellContent(0, [t("labels.print.new_code")]));
    }, "none", "text")];
    const table = (tableKey, tableRows, controlLabel, controlTestId, onClick) => {
        let elems, Options;
        return reactElement("div", createObj(ofArray([["data-test-id", tableKey], ["className", join(" ", ["h-[24rem]"])], (elems = [createElement(InfiniteTable, (Options = {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["object", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            RowSelection: "multiRow",
            SaveTableConfiguration: false,
            WithQueryParameters: false,
        }, {
            ColumnDefinitions: columns,
            Controls: singleton(new TableControlElement$1(0, [new TableControl$1(controlLabel, Recycle_Bin_1(), (selected) => {
                if (props.ComponentState === "enabled") {
                    props.Dispatch(onClick(map((row_3) => keyOf(row_3.Candidate), selected)));
                }
            }, true, false, controlTestId)])),
            Options: Options,
            TableKey: tableKey,
            TableRows: tableRows,
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    };
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_2 = toList(delay(() => {
        let elems_1, arg_1;
        return append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-4"])], (elems_1 = [createElement(TabsMenu, {
            Tabs: ofArray([{
                IsSelected: isActiveTabVisible,
                Label: t("labels.print.active_elements"),
                OnClick: () => {
                    setIsActiveTabVisible(true);
                },
                TestId: "print-labels-tab-active",
            }, {
                IsSelected: !isActiveTabVisible,
                Label: (arg_1 = {
                    count: length(props.RemovedCandidates),
                }, patternInput[1].t("labels.print.removed_elements", arg_1)),
                OnClick: () => {
                    setIsActiveTabVisible(false);
                },
                TestId: "print-labels-tab-removed",
            }]),
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => (isActiveTabVisible ? singleton_1(table("print-labels-table", rows, t("general.remove"), "print-labels-remove", (Item) => (new Msg(1, [Item])))) : singleton_1(table("print-labels-removed-table", removedRows, t("labels.print.add_to_list"), "print-labels-restore", (Item_1) => (new Msg(2, [Item_1])))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

class Derived extends Record {
    constructor(State, Dispatch, ComponentState, Selected, WithNewCode, TooMany, SingleCandidate, Summary) {
        super();
        this.State = State;
        this.Dispatch = Dispatch;
        this.ComponentState = ComponentState;
        this.Selected = Selected;
        this.WithNewCode = (WithNewCode | 0);
        this.TooMany = TooMany;
        this.SingleCandidate = SingleCandidate;
        this.Summary = Summary;
    }
}

function Derived_$reflection() {
    return record_type("Labels.PrintLabelsDialog.Derived", [], Derived, () => [["State", State_$reflection()], ["Dispatch", lambda_type(Msg_$reflection(), unit_type)], ["ComponentState", string_type], ["Selected", list_type(LabelPrintCandidate_$reflection())], ["WithNewCode", int32_type], ["TooMany", bool_type], ["SingleCandidate", option_type(LabelPrintCandidate_$reflection())], ["Summary", string_type]]);
}

function derive(t, props, state, dispatch) {
    const componentState = state.FormState.IsLoading ? "disabled" : "enabled";
    const selected = selectedCandidates(state);
    const withExistingCode = length(filter((candidate) => !isEmpty(candidate.ExistingCodes), selected)) | 0;
    const withNewCode = (length(selected) - withExistingCode) | 0;
    let summary;
    if (isEmpty(selected)) {
        summary = t("labels.print.summary_none");
    }
    else {
        const existingLabel = t("labels.print.summary_existing");
        const newAssignedLabel = t("labels.print.summary_new_assigned");
        const newReservedLabel = t("labels.print.summary_new_reserved");
        const labelsLabel = t("labels.print.summary_labels");
        const joinedParts = join(", ", toList(delay(() => append((withExistingCode > 0) ? singleton_1(`${withExistingCode} ${existingLabel}`) : empty_3(), delay(() => ((withNewCode > 0) ? (state.AssignCodes ? singleton_1(`${withNewCode} ${newAssignedLabel}`) : singleton_1(`${withNewCode} ${newReservedLabel}`)) : empty_3()))))));
        summary = (`${length(selected)} ${labelsLabel}: ${joinedParts}`);
    }
    return new Derived(state, dispatch, componentState, selected, withNewCode, length(selected) > maxLabelsPerPrint, (length(props.Items) === 1) ? tryExactlyOne(selected) : undefined, summary);
}

function codeSelect(t, derived) {
    const matchValue = derived.SingleCandidate;
    let matchResult, candidate_1;
    if (matchValue != null) {
        if (length(matchValue.ExistingCodes) > 1) {
            matchResult = 0;
            candidate_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return createElement(Select, {
                ComponentState: derived.ComponentState,
                IsClearable: false,
                Label: t("labels.print.choose_code"),
                NoOptionsMessage: "select.no_options",
                OnChange: (selection) => {
                    iterate((option) => {
                        derived.Dispatch(new Msg(3, [keyOf(candidate_1), option.value]));
                    }, toArray_1(selection));
                },
                Options: map((code) => ({
                    label: code,
                    value: code,
                }), candidate_1.ExistingCodes),
                PlaceholderKey: "select.no_options",
                TestId: "print-labels-code-select",
                Value: unwrap(map_1((code_1) => ({
                    label: code_1,
                    value: code_1,
                }), orElse(tryFind(keyOf(candidate_1), derived.State.PreferredCodes), tryHead(candidate_1.ExistingCodes)))),
            });
        default:
            return defaultOf();
    }
}

function assignCodesSection(t, props, derived) {
    return toList(delay(() => append(((derived.WithNewCode > 0) && props.CanAssignCodes) ? append(singleton_1(Checkbox({
        ComponentState: derived.ComponentState,
        IsChecked: derived.State.AssignCodes,
        Label: t("labels.print.assign_codes"),
        OnCheck: (arg) => {
            derived.Dispatch(new Msg(4, [arg]));
        },
        TestId: "print-labels-assign-codes",
    })), delay(() => singleton_1(createElement(InformationAlert, {
        Label: derived.State.AssignCodes ? t("labels.print.assign_codes_on_info") : t("labels.print.assign_codes_off_info"),
    })))) : empty_3(), delay(() => append(singleton_1(reactElement("p", {
        "data-test-id": "print-labels-summary",
        className: join(" ", ["text-sm", "font-bold"]),
        children: derived.Summary,
    })), delay(() => {
        const matchValue = FormState__getValidation(derived.State.FormState, t, "global");
        if (matchValue == null) {
            return empty_3();
        }
        else {
            return singleton_1(createElement(ErrorAlert, {
                Label: matchValue,
            }));
        }
    }))))));
}

function preview(props, derived) {
    let elems;
    const matchValue = tryHead(derived.Selected);
    if (matchValue == null) {
        return defaultOf();
    }
    else {
        const candidate = matchValue;
        const code = defaultArg(orElse(tryFind(keyOf(candidate), derived.State.PreferredCodes), tryHead(candidate.ExistingCodes)), sampleCodeFor(props.Configuration.CodePrefix));
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "rounded-xl", "bg-background", "p-4", "w-fit"])], (elems = [createElement(LabelPreview, {
            Code: code,
            Configuration: props.Configuration,
            Lines: resolveLines(add(Placeholder_code, code, add(Placeholder_storage, candidate.StorageName, add(Placeholder_name, candidate.DisplayName, sampleValues(candidate.Kind)))), textLinesFor(candidate.Kind, props.Configuration.TextLines)),
            LogoUrl: unwrap(props.LogoUrl),
            TestId: "print-labels-preview",
            Zoom: 1.5,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

function printButtonState(derived) {
    if (isEmpty(derived.Selected) ? true : derived.TooMany) {
        return "disabled";
    }
    else {
        return derived.ComponentState;
    }
}

export function PrintLabelsModalSheet(props) {
    let elems_2;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.Items, props.Configuration, props.LogoUrl, props.CanAssignCodes, t, props.OnClose, props.OnPrinted), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const derived = derive(t, props, state_1, dispatch);
    return createElement(ModalSheet, {
        CloseButtonTestId: "print-labels-close",
        Content: reactElement("div", createObj(ofArray([["data-test-id", "print-labels-sheet"], ["className", join(" ", ["flex", "flex-col", "gap-4", "p-4", "min-h-48"])], (elems_2 = toList(delay(() => {
            const matchValue = state_1.Candidates;
            if (matchValue.tag === 1) {
                const candidates = matchValue.fields[0];
                return append(singleton_1(createElement(CandidateTable, {
                    Candidates: filter((candidate) => !FSharpSet__Contains(state_1.Removed, keyOf(candidate)), candidates),
                    ComponentState: derived.ComponentState,
                    Dispatch: dispatch,
                    RemovedCandidates: filter((candidate_1) => FSharpSet__Contains(state_1.Removed, keyOf(candidate_1)), candidates),
                })), delay(() => {
                    let elems_1, elems, Label, Icon;
                    return singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4", "items-start"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4", "w-full", "max-w-2xl"])], (elems = toList(delay(() => append(singleton_1(codeSelect(t, derived)), delay(() => append(assignCodesSection(t, props, derived), delay(() => {
                        let arg_1;
                        return derived.TooMany ? singleton_1(createElement(WarningAlertText, {
                            Text: (arg_1 = {
                                max: maxLabelsPerPrint,
                            }, patternInput[1].t("labels.print.too_many_items", arg_1)),
                        })) : empty_3();
                    })))))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), preview(props, derived), createElement(Button, (Label = t("labels.print.print_button"), (Icon = Printer(), {
                        ComponentState: printButtonState(derived),
                        Icon: unwrap(Icon),
                        Label: Label,
                        OnClick: () => {
                            dispatch(new Msg(5, []));
                        },
                        TestId: "print-labels-confirm",
                        Variant: "primary",
                    })))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
                }));
            }
            else {
                return singleton_1(createElement(Skeleton, {
                    Variant: "table",
                }));
            }
        })), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))),
        Controls: empty_2(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: t("labels.print.title"),
    });
}

export function PrintLabelDialog(props) {
    let Title, elems_1, Label_2;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.Items, props.Configuration, props.LogoUrl, props.CanAssignCodes, t, props.OnClose, props.OnPrinted), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const derived = derive(t, props, state_1, dispatch);
    return createElement(Dialog, (Title = t("labels.print.title"), {
        Body: singleton(reactElement("div", createObj(ofArray([["data-test-id", "print-labels-dialog"], ["className", join(" ", ["flex", "flex-col", "gap-4", "min-w-[28rem]"])], (elems_1 = toList(delay(() => {
            let elems;
            const matchValue = state_1.Candidates;
            if (matchValue.tag === 1) {
                const candidates = matchValue.fields[0];
                return append((length(candidates) > 1) ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems = toList(delay(() => map((candidate) => {
                    const key_4 = keyOf(candidate);
                    return Checkbox({
                        ComponentState: candidate.HasStock ? derived.ComponentState : "disabled",
                        IsChecked: candidate.HasStock && !FSharpSet__Contains(state_1.Removed, key_4),
                        Label: candidate.StorageName,
                        OnCheck: (isChecked) => {
                            if (isChecked) {
                                dispatch(new Msg(2, [singleton(key_4)]));
                            }
                            else {
                                dispatch(new Msg(1, [singleton(key_4)]));
                            }
                        },
                        TestId: concat("print-labels-candidate-", ...rowKey(key_4[0], key_4[1])),
                    });
                }, candidates))), ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty_3(), delay(() => append(singleton_1(codeSelect(t, derived)), delay(() => append(assignCodesSection(t, props, derived), delay(() => singleton_1(preview(props, derived))))))));
            }
            else {
                return singleton_1(createElement(Skeleton, {
                    Variant: "normal",
                }));
            }
        })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: derived.ComponentState,
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "print-labels-cancel",
            Variant: "blueButton",
        }), createElement(TextButton, (Label_2 = t("labels.print.print_button"), {
            ComponentState: printButtonState(derived),
            Label: Label_2,
            OnClick: () => {
                dispatch(new Msg(5, []));
            },
            TestId: "print-labels-confirm",
            Variant: "blueButton",
        }))]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

export function printItem(kind, entityId) {
    return new LabelPrintItem(kind, entityId, undefined, undefined);
}

export function logoUrlFor(configuration) {
    const matchValue = activeConfiguration(configuration);
    let matchResult, labelConfiguration_1;
    if (matchValue != null) {
        if (matchValue.ShowLogo) {
            matchResult = 0;
            labelConfiguration_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return configuration.AppLogoConfiguration.WideLogoUrl;
        default:
            return undefined;
    }
}

export class PrintLabelOptions extends Record {
    constructor(Kind, EntityId, CustomerConfiguration, CanPrint, CanAssignCodes, OnPrinted) {
        super();
        this.Kind = Kind;
        this.EntityId = EntityId;
        this.CustomerConfiguration = CustomerConfiguration;
        this.CanPrint = CanPrint;
        this.CanAssignCodes = CanAssignCodes;
        this.OnPrinted = OnPrinted;
    }
}

export function PrintLabelOptions_$reflection() {
    return record_type("Labels.PrintLabelsDialog.PrintLabelOptions", [], PrintLabelOptions, () => [["Kind", LabelInventoryKind_$reflection()], ["EntityId", string_type], ["CustomerConfiguration", CustomerConfiguration_$reflection()], ["CanPrint", bool_type], ["CanAssignCodes", bool_type], ["OnPrinted", lambda_type(unit_type, unit_type)]]);
}

export function printLabelControl(options, openDialog) {
    const matchValue = activeConfiguration(options.CustomerConfiguration);
    let matchResult;
    if (matchValue != null) {
        if (options.CanPrint) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return openDialog;
        default:
            return undefined;
    }
}

export function PrintLabelDialogFor(props) {
    let configuration;
    const matchValue = activeConfiguration(props.Options.CustomerConfiguration);
    let matchResult, configuration_1;
    if (matchValue != null) {
        if ((configuration = matchValue, props.IsOpen)) {
            matchResult = 0;
            configuration_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return createElement(PrintLabelDialog, {
                CanAssignCodes: props.Options.CanAssignCodes,
                Configuration: configuration_1,
                IsOpen: props.IsOpen,
                Items: singleton(printItem(props.Options.Kind, props.Options.EntityId)),
                LogoUrl: unwrap(logoUrlFor(props.Options.CustomerConfiguration)),
                OnClose: props.OnClose,
                OnPrinted: props.Options.OnPrinted,
            });
        default:
            return defaultOf();
    }
}

